import React from 'react';
import { TREATED_BADGE } from '../../lib/teeth.js';

// «درمان‌شده» — the mark that says work was RECORDED on this tooth.
//
// Its own module for one reason: the chart draws it and the legend explains
// it, and a legend that draws its own approximation of a mark is a legend that
// drifts from the chart it is supposed to decode. Both render THIS.
//
// Drawn around the origin at chart scale (r ≈ 3 tooth-units) with no transform
// of its own — the caller positions it: `Tooth` on the mesio-incisal corner of
// the crown, the legend at 2.4× in the middle of a 38-unit box.

export default function TreatedBadge({ count = 1 }) {
  return (
    <>
      <circle r={TREATED_BADGE.r} fill={TREATED_BADGE.fill}
              stroke={TREATED_BADGE.ink} strokeWidth={0.9} />
      {count > 1 ? (
        <text
          x={0}
          y={0}
          textAnchor="middle"
          dominantBaseline="central"
          fill={TREATED_BADGE.ink}
          fontSize={3.6}
          fontWeight={700}
          // Western digits: this is a 3px glyph inside a disc, and the
          // chart's own numerals are Western throughout (the FDI labels,
          // the surface codes). A Persian numeral here would be the only
          // one and would not fit the same box.
        >
          {count > 9 ? '9+' : count}
        </text>
      ) : (
        /* A tick, drawn as a path rather than a glyph so it cannot be
           swapped by a font that lacks it. */
        <path
          d="M -1.5 0.1 L -0.45 1.2 L 1.6 -1.1"
          fill="none"
          stroke={TREATED_BADGE.ink}
          strokeWidth={0.9}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </>
  );
}
